
import Starwars from '../assets/projects/starwars.png'
import SportsCenter from '../assets/projects/sportCenter.png'
import RandomPerson from '../assets/projects/randomPerson.png'
import vetManagement from '../assets/projects/vetManagement.png'

export const projectReactData=[
    {
        id:1,
        name:"Starwars",
        image:Starwars,
        github:"https://github.com/AnilBASARAN/patika-react-starwars",
        live:"https://starwars-anilbasaran.netlify.app",
    },
    {
        id:2,
        name:"SportsCenter",
        image:SportsCenter,
        github:"https://github.com/AnilBASARAN/patika-sport-center",
        live:"https://anilbasaran-sportcenter.netlify.app",
    },
    {
        id:3,
        name:"RandomPerson",
        image:RandomPerson,
        github:"https://github.com/AnilBASARAN/randomPersonV2",
        live:"https://randompersonfetcher.netlify.app",
    },
    {
        id:4,
        name:"Vet Management",
        image:vetManagement,
        github:"https://github.com/AnilBASARAN/patika-vet-app",
        live:"https://anil-basaran-patika-vet-app.netlify.app",
    },


]